module.exports = __webpack_public_path__ + "static/media/person_add.c6f45121.svg";